import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    sortArgs: [
        {
            name: "date_modified",
            direction: "descending",
        },
    ],
};
export var sortSlice = createSlice({
    name: "sort",
    initialState: initialState,
    reducers: {
        setSortArgs: function (state, data) {
            state.sortArgs = data.payload;
        },
    },
});
export var setSortArgs = sortSlice.actions.setSortArgs;
export default sortSlice.reducer;
